import { useCallback, useEffect, useState } from 'react';
import { getGenerateVideoConfig } from '../api/generateVideo.api';
import type { GenerateVideoConfig } from '../types';

export function useGenerateVideoConfig() {
  const [config, setConfig] = useState<GenerateVideoConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  const refresh = useCallback(async () => {
    try {
      setConfig(await getGenerateVideoConfig());
      setFailed(false);
    } catch {
      setFailed(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { config, loading, failed, refresh };
}
